import React from "react";
import PropTypes from "prop-types";

const SchedulingInstructions = ({
  enableBuiltInScheduling,
  schedulingInstructions,
  scheduleRequired,
  onEnableBuiltInSchedulingChangeCallback,
  onSchedulingInstructionsChangeCallback,
  onScheduleRequiredChangeCallback,
}) => (
  <div>
    <h2>Scheduling Instructions</h2>
    <input
      onChange={onEnableBuiltInSchedulingChangeCallback}
      type="checkbox"
      id="enableBuiltInScheduling"
      checked={enableBuiltInScheduling}
    />
    <label htmlFor="enableBuiltInScheduling"> Includes a picker for desired Shoot Date/Time?</label>
    <div id="scheduleRequiredWrapper">
      <input
        onChange={onScheduleRequiredChangeCallback}
        type="checkbox"
        id="scheduleRequired"
        checked={scheduleRequired}
      />
      &nbsp;
      <label htmlFor="scheduleRequired">
        Require date/time to be selected. Unchecked will make this an optional item on the order form
      </label>
    </div>
    <div id="scheduling-instructions" style={{ display: enableBuiltInScheduling ? "block" : "none" }}>
      <ul className="help">
        <li>
          The normal shoot date/time picker requires both a date and time; if this doesn&#39;t suit your needs then
          un-check the box and use a custom field (next step)
        </li>
        <li>Any text entered below will be shown next to the Date/Time picker</li>
      </ul>
      <textarea
        name="schedulingInstructions"
        id="schedulingInstructions"
        cols="40"
        rows="10"
        value={schedulingInstructions}
        onChange={event => onSchedulingInstructionsChangeCallback(event.target.value)}
      />
    </div>
  </div>
);

SchedulingInstructions.propTypes = {
  enableBuiltInScheduling: PropTypes.bool,
  scheduleRequired: PropTypes.bool,
  schedulingInstructions: PropTypes.string,
  onEnableBuiltInSchedulingChangeCallback: PropTypes.func.isRequired,
  onSchedulingInstructionsChangeCallback: PropTypes.func.isRequired,
  onScheduleRequiredChangeCallback: PropTypes.func.isRequired,
};

export default SchedulingInstructions;
